import { Component, ReactNode } from "react";
import { AlertCircle } from "lucide-react";

type Props = {
  children: ReactNode;
  title?: string;
  description?: string;
  className?: string;
};

type State = {
  hasError: boolean;
};

export class SectionErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("SectionErrorBoundary caught:", error, info);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        className={this.props.className ?? "rounded-xl border border-amber-200 bg-amber-50/70 p-4"}
        role="status"
      >
        <div className="flex items-start gap-3">
          <AlertCircle className="mt-0.5 h-5 w-5 text-amber-600" />
          <div className="space-y-1">
            <p className="text-sm font-bold text-amber-900">
              {this.props.title ?? "Bloco temporariamente indisponivel"}
            </p>
            <p className="text-xs text-amber-700">
              {this.props.description ??
                "Este painel falhou ao renderizar, mas o restante do dashboard continua disponivel."}
            </p>
          </div>
        </div>
      </div>
    );
  }
}
